import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsHttpService } from '../../../../../core/settings';
import { MachineRouteService } from '../../machine-route.service';

@Component({
  selector: 'kt-calib-settings',
  templateUrl: './calib-settings.component.html',
  styleUrls: ['./calib-settings.component.scss']
})
export class CalibSettingsComponent implements OnInit {

	selectedMachine: any;

	calib;

	texts = {
		coffeeGPS: "Coffee (g/sec)",
		auger1GPS: "Auger 1 (g/sec)",
		auger2GPS: "Auger 2 (g/sec)",
		auger3GPS: "Auger 3 (g/sec)",
		auger4GPS: "Auger 4 (g/sec)",
		auger5GPS: "Auger 5 (g/sec)",
		water1ppl: "Water 1 (pulse/ltr)",
		water2ppl: "Water 2 (pulse/ltr)",
		water3ppl: "Water 3 (pulse/ltr)",
		water4ppl: "Water 4 (pulse/ltr)",
		coffeeWaterppl: "Coffee Water (pulse/ltr)",
		brewTime: "Brew Time (secs)"
	};

	keys = [];

  constructor(private http: SettingsHttpService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private machineRouteService: MachineRouteService) { }

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;
	this.getCalibSettings();
  }

  getCalibSettings(){
	this.http.getCalibSettings(this.selectedMachine.machine_id)
	.subscribe((result:any) => {
		console.log(result);
		if(result){
			this.calib = result;
			delete result.machine_id;
			delete result.time_stamp;
			this.keys = Object.keys(result);
			// for(let item of Object.keys(result)){
			// 	console.log(item);
			// }
			this.cdr.detectChanges();
		}

	});
  }

}
